import { TFunction } from 'i18next';

import { NoteCamera, NoteSource, NoteUser } from 'shiftNotes/_types';

interface AuthoredNote {
  user: Pick<NoteUser, 'first_name' | 'last_name'> | null;
  source: NoteSource;
  cameras?: Pick<NoteCamera, 'display_name'>[];
}

export default function getNoteAuthorName(
  note: AuthoredNote,
  t: TFunction
): string {
  if (note.user) {
    return `${note.user.first_name} ${note.user.last_name}`.trim();
  }

  const cameraNames = (note.cameras ?? []).map((camera) => camera.display_name);
  if (cameraNames.length > 0) {
    return cameraNames.join(', ');
  }

  return t(`pageShiftNotes:noteSource.${note.source}`, { defaultValue: '' });
}
